import { getMoment } from '../helpers/time-master';

export function useIsMarketHours() {
  const now = getMoment();
  const day = now.format('ddd').toLowerCase();

  // Sat, Sun is market holiday
  if (day === 'sun' || day === 'sat') {
    return false;
  }

  const marketStart = getMoment().startOf('day').add(9, 'hours');
  const marketEnd = getMoment()
    .startOf('day')
    .add(15, 'hours')
    .add(35, 'minutes');

  // Before marketStart
  if (now.isBefore(marketStart)) {
    return false;
  }

  // After marketEnd
  if (now.isAfter(marketEnd)) {
    return false;
  }

  // Market is on
  return true;
}
